module.exports = __webpack_public_path__ + "img/MX-C130095B-BE.30864a70.png";